export default __webpack_public_path__ + "images/b21e88ed67282cb54aa9018f0c7d010d.svg";